import { render, staticRenderFns } from "./xcws.vue?vue&type=template&id=b1d96b5e&scoped=true&"
import script from "./xcws.vue?vue&type=script&lang=js&"
export * from "./xcws.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1d96b5e",
  null
  
)

export default component.exports